import "bootstrap-icons/font/bootstrap-icons.css";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Pagination from "../../../common/components/Pagination";
import * as actions from "../../redux/SettingAction";

export const VipDownline = ({ setSwalProps }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const settingState = useSelector(({ setting }) => setting, shallowEqual);
  const [searchusername, setSearchusername] = useState("");
  const [pagenum, setPagenum] = useState(0);

  const fetchDownline = (page) => {
    setPagenum(page ?? 0);
    const params = {
      searchusername,
      pagenum: page ?? 0,
    };

    dispatch(actions.getVipDownlineList(params));
  };

  useEffect(() => {
    fetchDownline();
  }, []);

  return (
    <div>
      <div className="input-group flex-fill">
        <input
          type="text"
          className="form-control text-font2 py-1"
          placeholder={intl.formatMessage({ id: "search" })}
          aria-describedby="basic-addon1"
          value={searchusername}
          onChange={(e) => {
            setSearchusername(e.target.value);
          }}
        />
        <span
          className="input-group-text"
          id="basic-addon1"
          onClick={() => fetchDownline()}
        >
          <i className="fa fa-search" />
        </span>
      </div>
      {settingState.vipDownlineList ? (
        <div>
          {settingState.listLoading ? (
            <div className="d-flex align-items-center justify-content-center py-5">
              <div
                className="spinner-border"
                role="status"
                style={{ scale: "1.2" }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div>
              <div className="d-flex align-items-center justify-content-start my-2">
                <div
                  className="p-1 rounded col-3"
                  style={{ backgroundColor: "#1c1e23" }}
                >
                  <div className="text-center">
                    {intl.formatMessage({ id: "member" })}
                  </div>
                  <div className="text-center">
                    {settingState.vipDownlineList?.totalmember}
                  </div>
                </div>
              </div>
              {settingState.vipDownlineList.memberVipDownlineLists.length >
              0 ? (
                <div>
                  {settingState.vipDownlineList.memberVipDownlineLists.map(
                    (downline, index) => (
                      <div
                        className="card mb-2"
                        key={index}
                        style={{ width: "95%", margin: "0 auto" }}
                      >
                        <div
                          className="card-body rounded"
                          style={{
                            background: "rgba(46, 50, 58, 1)",
                            color: "white",
                          }}
                        >
                          <div className="d-flex justify-content-between">
                            <div className="text-font2">
                              {downline.username}
                            </div>
                            <div>
                              <div className="text-muted fst-italic text-font1">
                                {downline.registerdate}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              ) : (
                <div className="d-flex py-5 align-items-center justify-content-center">
                  <div className="text-muted d-flex align-items-center justify-content-center flex-column">
                    <i
                      style={{ color: "white" }}
                      className="bi bi-search fs-1 mb-3"
                    />
                    <div className="text-font2" style={{ color: "white" }}>
                      {intl.formatMessage({ id: "noRecordFound" })}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        <Skeleton className="w-100" height="600px" />
      )}
      {parseInt(settingState.vipDownlineList?.totalpage ?? "0") > 1 && (
        <Pagination
          currentPage={pagenum}
          totalPages={parseInt(settingState.vipDownlineList?.totalpage ?? "0")}
          onPageChange={(page) => setPagenum(page)}
        />
      )}
    </div>
  );
};
